import type { ReactNode } from 'react'
import { Folder, Image, Slash, Upload } from 'lucide-react'

export interface AttachMenuProps {
  onUpload: () => void
  onPool: () => void
  onSlash: () => void
  onScreenshot: () => void
}

export function AttachMenu({ onUpload, onPool, onSlash, onScreenshot }: AttachMenuProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-lg">
      <Item
        icon={<Upload className="h-4 w-4 text-brand-600" />}
        title="Datei hochladen"
        subtitle="Lokal · nur dieser Prompt, nicht im Pool"
        onClick={onUpload}
        highlight
      />
      <Item
        icon={<Folder className="h-4 w-4 text-neutral-500" />}
        title="Aus Dokumenten Pool (@)"
        onClick={onPool}
      />
      <Item
        icon={<Slash className="h-4 w-4 text-neutral-500" />}
        title="Skills & Befehle (/)"
        onClick={onSlash}
      />
      <Item
        icon={<Image className="h-4 w-4 text-neutral-500" />}
        title="Screenshot / Foto"
        onClick={onScreenshot}
      />
    </div>
  )
}

function Item({
  icon,
  title,
  subtitle,
  onClick,
  highlight,
}: {
  icon: ReactNode
  title: string
  subtitle?: string
  onClick: () => void
  highlight?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-start gap-2.5 px-3 py-2.5 text-left hover:bg-neutral-50 ${
        highlight ? 'bg-brand-50/50' : ''
      }`}
    >
      <span className="mt-0.5">{icon}</span>
      <span className="min-w-0">
        <span className="block text-sm font-medium text-neutral-800">{title}</span>
        {subtitle && <span className="block text-xs text-neutral-400">{subtitle}</span>}
      </span>
    </button>
  )
}
